import { MANAGE_EXTRA_ACTIVITY_MODES } from 'common/activeElements/modals/ManageExtraActivity/const';
import {
	POST_DRIVING_EXTRA_ACTIVITY_OPTIONS,
	PRE_DRIVING_EXTRA_ACTIVITY_OPTIONS,
} from 'common/ActivityChip/utils/extraActivities';
import { DRIVING_ACTIVITY_TYPE } from 'constants/activityTypes';

export const EXTRA_ACTIVITY_TIMELINE_SIDES = {
	before: 'before',
	after: 'after',
};

const REJECTED_EXTRA_ACTIVITY_STATUS = 'rejected';

const getActivity = (record) => record?.activity ?? record ?? {};

const getStationForSide = (activity, side) =>
	side === EXTRA_ACTIVITY_TIMELINE_SIDES.before ? activity?.fromStation : activity?.toStation;

const getStationKey = (station) => station?.id ?? station?.code ?? null;

const isSameStation = (left, right) => {
	const leftKey = getStationKey(left);
	const rightKey = getStationKey(right);

	return Boolean(leftKey && rightKey && leftKey === rightKey);
};

const hasDuplicateForStation = (activity, option, station) =>
	(activity?.extraActivities ?? []).some(
		(extraActivity) =>
			extraActivity?.status !== REJECTED_EXTRA_ACTIVITY_STATUS &&
			extraActivity?.activityType === option.type &&
			(isSameStation(extraActivity?.fromStation, station) ||
				isSameStation(extraActivity?.toStation, station))
	);

export const getTimelineExtraActivityStationCode = (record, side) => {
	const activity = getActivity(record);
	const station = getStationForSide(activity, side);

	return station?.code ?? station?.name ?? station?.id ?? '';
};

export const isTimelineExtraActivityEligible = (record) => {
	const activity = getActivity(record);

	return Boolean(
		activity?.activityType === DRIVING_ACTIVITY_TYPE &&
			activity?.rideId &&
			activity?.sequenceGroupId &&
			activity?.fromStation?.id &&
			activity?.toStation?.id
	);
};

export const getTimelineExtraActivityOptions = (record, side) => {
	if (!isTimelineExtraActivityEligible(record)) return [];

	const activity = getActivity(record);
	const station = getStationForSide(activity, side);
	const sideOptions =
		side === EXTRA_ACTIVITY_TIMELINE_SIDES.before
			? PRE_DRIVING_EXTRA_ACTIVITY_OPTIONS
			: POST_DRIVING_EXTRA_ACTIVITY_OPTIONS;

	return sideOptions.filter((option) => !hasDuplicateForStation(activity, option, station));
};

export const buildTimelineExtraActivityPayload = ({ record, side, activityType }) => {
	const activity = getActivity(record);
	const station = getStationForSide(activity, side);

	return {
		mode: MANAGE_EXTRA_ACTIVITY_MODES.add,
		selectedExtraActivity: activityType,
		locations: [activity?.fromStation, activity?.toStation].filter(Boolean),
		lockActivityFields: true,
		initialData: {
			rideId: activity?.rideId,
			sequenceGroupId: activity?.sequenceGroupId,
			stationId: station?.id,
		},
	};
};
